<template>
    <div class="animated fadeIn">
  
      
      <b-card class="card-accent-info">

        <div slot="header">
              Contas a Receber
              <div class="card-header-actions">
                
                <b-link href="#" class="card-header-action btn-help">
                  <i class="icon-question" @click="openHelp('/?page=finance/accountsreceivable')"></i>
                </b-link>
                
                <!--
                <b-link href="#" class="card-header-action btn-helpvie">
                  <i class="icon-film"></i>
                </b-link>
                -->
              </div>
        </div>

        <b-card-body>
  
          <b-row>
            <b-col cols="auto" class="mr-auto">
              <!--
                <b-form-group>
                    <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
              </b-form-group>
              -->
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <b-button variant="vine" class="mr-1 btn-brand" @click="enableDisable()"  v-show="tableSelectable"><i class="fa fa-toggle-on"></i><span>Alterar Status</span></b-button>
                &nbsp;
                <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Nova Conta a Receber</span></b-button>
              </b-form-group>
            </b-col>
          </b-row>
              
  
          <b-row>

            <b-col cols="auto">
              <b-form-group >
                  <label for="perPage">Empresa</label>
                  <b-form-select v-model="filters.companyId" id="filterCompany"
                    :plain="true"
                    :options="this.companyDDL"
                    @change="refreshByCompany(filters.companyId);"
                    >
                  </b-form-select>
                </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group >
                  <label for="filterCostCenter">Centro de Custo</label>
                  <b-form-select v-model="filters.costCenterId" id="filterCostCenter" value-field="value" text-field="text"
                    :plain="true"
                    :options="this.selectCostCenterDDL"                   
                    >
                  </b-form-select>
                </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="name">Filtro</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group >
                  <label for="startDate">Período</label>
                  <b-form-input v-model="filters.startDate" type="date" id="startDate"></b-form-input>
                </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group >
                  <label for="startDate">&nbsp;&nbsp;&nbsp;</label>
                  <b-form-input v-model="filters.endDate" type="date" id="endDate"></b-form-input>
                </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group >
                  <label for="filterStatus">Status</label>
                  <b-form-select v-model="filters.statusId" id="filterStatus" value-field="value" text-field="text"
                    :plain="true"
                    :options="this.selectStatusDDL"
                    >
                  </b-form-select>
                </b-form-group>
            </b-col>

            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>
            <!--
            <b-col cols="auto" class="mr-auto">
              <b-form-group>
                  <label for="name">Filtro</label>
                  <b-form-input type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>
          -->
            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50,100]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>
        
  
            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                selectable
                @row-selected="onRowSelected"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                @row-clicked="rowClicked"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped
  
                >
  
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>
  
                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                              <b-button size="sm" variant="primary"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                              <!-- <a class="button" @click="row.toggleDetails"><i class="fa fa-search fa-md text-primary"></i></a> -->
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                
                <template #row-details="row">
                    <b-card>
                        <b-row>
                            <b-col class="small">Observação</b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-primary">{{ row.item.notes }}</b-col>
                        </b-row>
                        <b-row v-show="row.item.paymentVoucher && row.item.paymentVoucher.length > 0">
                            <b-col class="small">Comprovante de Pagamento</b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-primary">{{ row.item.paymentVoucher }}</b-col>
                        </b-row>
                    </b-card>
                </template>
                
                <template v-slot:cell(totalValue)="data">
                    {{ !isNaN(data.item.totalValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.totalValue) : '' }}
                </template>

                <template v-slot:cell(dueDate)="data">
                    {{ $utils.dateStringFormat(data.item.dueDate) }}
                </template>

                <template v-slot:cell(fees)="data">
                    <p class="text-danger"><b>{{ !isNaN(data.item.fees) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.fees) : '' }}</b></p>
                </template>

                <template v-slot:cell(paymentValue)="data">
                    {{ !isNaN(data.item.paymentValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.paymentValue) : '' }}
                </template>
                <template v-slot:cell(valueToPay)="data">
                    <b>{{ new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( getValueToPay(data.item))  }}</b>
                </template>

                <template v-slot:cell(description)="data">
                    {{ data.item.description  }}
                    <span v-show="data.item.number"><br><span class="text-muted small">Nota: </span>{{ data.item.number }}{{ data.item.noteCode ? '-' + data.item.noteCode : ''}}</span>
                    <br><span class="text-primary">{{  data.item.notes }}</span>
                </template>
                <template v-slot:cell(costcenter)="data">
                    {{ data.item.costCenterCode  }} {{ data.item.costCenterName }}
                </template>

                <template v-slot:cell(st)="data">
                    <c-switch class="" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
                <template v-slot:cell(ispublic)="data">
                    <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
                <template v-slot:cell(action)="data">
                  <!-- <a class="button" @click="deleteAccountsReceivable(data.item)"><i class="fa fa-close text-danger fa-lg"></i></a> -->
                  <b-button size="sm" variant="danger" @click="deleteAccountsReceivable(data.item)" class="mr-1 btn-brand"><i class="fa fa-close"></i></b-button>
                  
                </template>

            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>
  
  
        </b-card-body>
     </b-card>
  
     <b-modal
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Conta a Receber"
              size="lg"
              @hidden="onCloseModal"
              >

        <b-nav fill>
          <b-nav-item :active="tabInfo=='D'" @click="tabInfo='D'">Detalhes da Conta</b-nav-item>
          <b-nav-item :active="tabInfo=='P'" @click="tabInfo='P'">Pagamentos</b-nav-item>
          <b-nav-item :active="tabInfo=='F'" @click="tabInfo='F'">Arquivos</b-nav-item>
        </b-nav>

        <div v-show="tabInfo=='D'">
            <b-card> 

            <b-form @submit.stop.prevent="onSubmit">
      
            <div class="animated fadeIn">
          
            <b-row>
              <b-col md="12">
                
                <b-form>
                  <b-form-group
                  description=""
                  label="Número da nota:"
                  label-for="number"
                  :label-cols="3"
                  :horizontal="true">
                  <table width="100%">
                  <tr>
                    <td cols="1">
                      <b-form-input v-model="selectedItem.number" id="number" type="number"></b-form-input>
                    </td>
                    <td>
                      &nbsp;&nbsp;Emissão:&nbsp;
                    </td>
                    <td>
                      <b-form-input v-model="selectedItem.noteCode" id="noteCode" type="text" style="width: 40px"></b-form-input>
                    </td>
                    <td>
                      &nbsp;&nbsp;CPF/CNPJ:&nbsp;
                    </td>
                    <td cols="2">
                          <masked-input
                            type="text"
                            name="doc"
                            class="form-control cols-md-2"
                            v-model="personDoc"
                            :mask="(personDoc && personDoc.length > 14) ? [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/] : [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]"
                            :guide="false"
                            placeholderChar="#"
                            @blur="getPersonByDoc(personDoc)"
                            >
                          </masked-input>
                    </td>
                  </tr>               
                </table>   
                </b-form-group>          
                </b-form>
                </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                
                <b-form>
                  <b-form-group
                  description=""
                  label="Cliente:"
                  label-for="personName"
                  :label-cols="3"
                  :horizontal="true">
                    <b-row>
                      <b-col sm="2"><b-form-input v-model="personCode" id="personCode" type="text" @blur="getPersonByCode(personCode)"></b-form-input></b-col>
                      <b-col>
                        <person-component
                          :companyId="this.filters.companyId"
                          :personName="personName"
                          @item-selected="handleSelectedPerson"
                        ></person-component>
                       
                      </b-col>
                    </b-row>
                                   
                </b-form-group>          
                </b-form>
                </b-col>
            </b-row>

            <hr>
              <b-row>
                <b-col md="12">
                  <b-form>
                    <b-form-group
                    description=""
                    label="Centro de custo"
                    label-for="costcenter"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-select id="basicSelectLg"
                      v-model="selectedItem.costCenterId"
                      :plain="true"
                      :options="costCenterDDL"
                      value="Please select">
                    </b-form-select>
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form>
                    <b-form-group
                    description=""
                    label="Descrição"
                    label-for="description"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-textarea
                      id="description"
                      v-model="selectedItem.description"
                      placeholder=""
                      rows="3"
                    ></b-form-textarea>
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>

           

              <b-row>
                <b-col md="12">
                  <b-form>
                    <b-form-group
                    description=""
                    label="Data de vencimento"
                    label-for="dueDate"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-input v-model="selectedItem.dueDate" type="date" id="dueDate" class="w-50" :class="dueDateField"></b-form-input>
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>
      
              <b-row>
                <b-col md="12">
                  <b-form>
                    <b-form-group
                    description=""
                    label="Valor"
                    label-for="totalValue"
                    :label-cols="3"
                    :horizontal="true">
                       <b-form-input v-model="selectedItem.totalValue" id="totalValue" type="number" @change="changeInstallment()" class="w-50" :class="totalValueField" v-show="!selectedItem.id"></b-form-input>
                       <span v-show="selectedItem.id && selectedItem.id > 0">R$ {{ $utils.numberFormat(selectedItem.totalValue) }}</span>
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>

              <b-row v-if="this.selectedItem.id > 0">
                <b-col md="12">
                  <b-form>
                    <b-form-group
                    description=""
                    label="Juros"
                    label-for="fees"
                    :label-cols="3"
                    :horizontal="true">
                       <b-form-input v-model="selectedItem.fees" id="fees" type="number" class="w-50"></b-form-input>
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>
      
              <!--
              <b-row v-if="this.selectedItem.id > 0">
                <b-col md="12">
                  <b-form>
                    <b-form-group
                    description=""
                    label="Descontos"
                    label-for="discount"
                    :label-cols="3"
                    :horizontal="true">
                       <b-form-input v-model="selectedItem.discount" id="discount" type="number" class="w-50"></b-form-input>
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>
              -->

              <b-row v-if="this.selectedItem.id > 0">
                <b-col md="12">
                  <b-form>
                    <b-form-group
                    description=""
                    label="Total"
                    label-for="totalValue"
                    :label-cols="3"
                    :horizontal="true">
                       <b>R$ {{ $utils.numberFormat(accountTotal) }}</b>
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>

              <b-row v-if="this.selectedItem.id > 0">
                <b-col md="12">
                  <b-form>
                    <b-form-group
                    description=""
                    label="Valor pago"
                    label-for="totalValue"
                    :label-cols="3"
                    :horizontal="true">
                       <span>R$ {{ $utils.numberFormat(selectedItem.paymentValue) }}</span>
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>

              <b-row v-if="this.selectedItem.id > 0">
                <b-col md="12">
                  <b-form>
                    <b-form-group
                    description=""
                    label="Valor a pagar"
                    label-for="totalValue"
                    :label-cols="3"
                    :horizontal="true">
                       <b class="text-danger">R$ {{ $utils.numberFormat(totalToPay) }}</b>
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>

              <b-row v-if="this.selectedItem.id == null">
                <b-col md="12">
                
                    <b-form-group
                      description="Se habilitado será criado uma conta a pagar para os 3 meses subsequentes"
                      label=""
                      label-for="description"
                      :label-cols="3"
                      :horizontal="true">
                      <input id="recurrent" type="checkbox" value="test" v-model="selectedItem.recurrent"> Pagamento Recorrente
                    </b-form-group>          

                  </b-col>
                </b-row>


        
                <b-row v-if="this.selectedItem.id == null">
                <b-col md="12">
                  <b-form>
                    <b-form-group
                    description=""
                    label="Parcelas"
                    label-for="notes"
                    :label-cols="3"
                    :horizontal="true">
                    <tr width="100%">
                      <td><b-form-select v-model="selectedItem.installments" id="installments"
                      :plain="true"
                      :options="[1,2,3,4,5,6,7,8,9,10,11,12]"
                      @change="changeInstallment()"
                      >
                      </b-form-select>
                      </td>
                      <td>
                        &nbsp;&nbsp;Período:&nbsp;
                      </td>
                      <td><b-form-select v-model="selectedItem.installmentDays" id="installmentsDays"
                      :plain="true"
                      :options="[15,30]"
                      @change="changeInstallment()"
                      >
                      </b-form-select>
                      </td>
                      <td>
                        &nbsp;dias
                      </td>
                    </tr>
                    
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>
              
            <div v-if="!selectedItem.id && selectedItem.installments > 1">
     
            
            
            <b-row v-for="installment in selectedItem.accounts" :key="installment.id">
              <b-col md="12">
                <b-form>
                  <b-form-group
                  description=""
                  :label="'Parcela ' + installment.installment + ': '"
                  :label-cols="3"
                  :horizontal="true">
                  <table width="100%">
                    <tr>
                      <td><b-form-input v-model="installment.dueDate" type="date" id="dueDate"></b-form-input></td>
                      <td>&nbsp;&nbsp;Valor: &nbsp;</td>
                      <td><b-form-input v-model="installment.totalValue" id="totalValue" type="number"></b-form-input></td>
                    </tr>
                  </table>
                  
                </b-form-group>          
                </b-form>
              </b-col>
            </b-row>
  
            </div>

            <hr>
              <b-row>
                <b-col md="12">
                  <b-form>
                    <b-form-group
                    description=""
                    label="Observações"
                    label-for="notes"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-textarea
                      id="notes"
                      v-model="selectedItem.notes"
                      placeholder=""
                      rows="3"
                    ></b-form-textarea>
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>

              <b-input-group class="mb-4">
                  <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
              </b-input-group>
            
              <div slot="footer" class="text-right">
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="changeStatus(selectedItem, 1)" v-show="this.selectedItem.id && this.selectedItem.statusId != 1"><i class="fa fa-recycle"></i><span>Reabrir Conta a Receber</span></b-button>
                <b-button variant="html5" class="mr-1 btn-brand" @click="changeStatus(selectedItem, 2)" v-show="this.selectedItem.id && this.selectedItem.statusId == 1"><i class="fa fa-times"></i><span>Cancelar Conta a Receber</span></b-button>
                <b-button variant="github" class="mr-1 btn-brand" @click="save()" v-show="!this.selectedItem.id || this.selectedItem.statusId == 1"><i class="fa fa-check"></i><span>Salvar Conta a Receber</span></b-button>
              
              </div>
                    
            </div>
            </b-form>
          </b-card>
        </div>



        <div v-show="tabInfo=='P'">
          <b-card> 
              <payment-grid-component 
                :companyId="filters.companyId" 
                :accountType="accountType"
                :item="selectedItem"
                @diff-changed="differenceChanged"
                ></payment-grid-component>
          </b-card>

        </div>
        <div v-show="tabInfo=='F'">
          <b-card> 
              <accounts-file-grid-component
                :companyId="filters.companyId" 
                :accountType="accountType"
                :item="selectedItem"
                ></accounts-file-grid-component>
          </b-card>

        </div>
  
      </b-modal>
  
      <b-modal title="Excluir" class="modal-delete" v-model="deleteModal" @ok="deleteItem" cancel-title="Cancelar" >
          {{ deleteMessage }}
      </b-modal>
     
    </div>
  
  </template>
  
  <script>

  import PersonComponent from '../../components/PersonComponent'
  
  import Vue from 'vue'
  import axios from "axios";
  
  import { Switch as cSwitch } from '@coreui/vue'
  import MaskedInput from 'vue-text-mask'  
  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  import PaymentGridComponent from './PaymentGridComponent'
  import AccountsFileGridComponent from './AccountsFileGridComponent'

  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, description: '', st: 'A', recurrent: false, _rowVariant: '', installments: 1, installmentDays: 30, accounts: []}
  
  export default {
    name: 'tables',
    components: {
      Event,
      cSwitch,
      MaskedInput,
      PersonComponent,
      PaymentGridComponent,
      AccountsFileGridComponent
    },
    data: () => {
      return {
        deleteModal: false,
        deleteMessage: '',

        dueDateField: '',
        totalValueField: '',

        statusDDL: [],
        accountType: "R",
        acountPaymentModal: false,

        personDoc: '',
        personCode: '',
        personName: '',

        tabInfo: "D",
        companyDDL: [],
        costCenterDDL: [],
        isBusy: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },
  
        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
        editModal: false,
        filters: {
          companyId: 0,
          costCenterId: 0,
          statusId: 0,
          key: '',
          startDate: null,
          endDate: null
        },
  
        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",
  
        selectedItem: newItem,
        items: [        
        ],
        fields: [
          {key: 'show_details', label: "", thStyle: { width: "40px" } },
          //{key: 'id' },
          {key: 'costcenter', label: 'Centro de Custo', sortable: true },
          {key: 'description', label: 'Conta a Receber', sortable: true },
          {key: 'dueDate', label: 'Data', sortable: true, class: 'text-center', thStyle: { width: "150px" }},
          {key: 'totalValue', label: 'Valor Original', sortable: true, class: 'text-right', thStyle: { width: "150px" }},
          {key: 'fees', label: 'Juros', sortable: true, class: 'text-right', thStyle: { width: "100px" }},
          {key: 'paymentValue', label: 'Valor Recebido', sortable: true, class: 'text-right', thStyle: { width: "150px" } },
          {key: 'valueToPay', label: 'A Receber', sortable: true, class: 'text-right', thStyle: { width: "120px" }},
          //{key: 'ispublic', label: 'Público', sortable: true, thStyle: { width: "40px" } },
          {key: 'statusName', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "150px" } },
          {key: 'action', label: '', sortable: false, thStyle: { width: "40px" } }
        ],
        
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 50
      }
    },
   
    computed: {
      onClosePayment() {
        console.log("Fechando pagamento")
      },
      accountTotal() {
        var total = this.selectedItem.totalValue && this.selectedItem.totalValue > 0 ? this.selectedItem.totalValue : 0
          if(this.selectedItem.fees)
              total = total + Number(this.selectedItem.fees)
          if(this.selectedItem.discount)
              total = total - this.selectedItem.discount
        return total
      },
      totalToPay() {
        var total = this.accountTotal
          if(this.selectedItem.paymentValue)
              total = total - this.selectedItem.paymentValue
          return total
      },
      selectStatusDDL() {
          var list = [...this.statusDDL]
          list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
          list.unshift({ value: '0' , text: '- Todos -' })
          return list
      },
      selectCostCenterDDL: function() {
          var list = [...this.costCenterDDL]
          list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
          list.unshift({ value: '0' , text: '- Todos -' })
          return list
      },
      totalRows: function () { return this.getRowCount() },
      filteredItems() {
        try {
            const str = String(this.filters.costCenterId);
            //console.log( "01.03.01 alexandre".startsWith(String(this.filters.costCenterId)) ? "Verdadeiro" : "falso" )
            return this.items.filter(item => {

              return (this.filters.key == '' 
                || this.$utils.filterString(item.description, this.filters.key))
                && (this.filters.statusId == 0 || item.statusId == this.filters.statusId)     
                && (!this.filters.costCenterId || this.filters.costCenterId == null || String(item.costCenterCode).startsWith(String(getCostCenterCode(this.filters.costCenterId))) )
            })
        }
        catch(e) {
            return this.items;
        }
      }
    },
    methods: {
      async deleteItem() {
        var s = this
        var currentUser = this.$store.state.currentUser;

        await axios.delete(
            this.$store.state.ws_url + "/finance/ar?id=" + this.selectedItem.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
          s.refreshData()
        }).catch(function (error) {
          console.log(error);
        });
      },

      deleteAccountsReceivable(item) {
        if(item.statusId == 1 || item.statusId == 2) {
          this.deleteMessage = 'Deseja realmente excluir a conta?'
          this.deleteModal = true
          this.selectedItem = item          
        }
        else {
          toast ({
            type: VueNotifications.types.warn,
            title: 'Excluir',
            message: 'Não foi possível excluir a conta. Apenas contas em Aberto ou Canceladas podem ser excluídas.',
            timeout: 5000
          })
        }

      },

      onCloseModal() {
        this.refreshData()
      },
      
      getValueToPay(item) {
        var total = item.totalValue
        if(item.fees && item.fees > 0)
          total = total + item.fees
        if(item.discount && item.discount > 0)
          total = total - item.discount
        if(item.paymentValue && item.paymentValue > 0)
          total = total - item.paymentValue
        return total
      },

      getCostCenterCode(id) {
        return this.costCenterDDL.find(item => item.value === id).text
      },
      changeInstallment: function() {

      var installments = this.selectedItem.installments
      var installmentDays = this.selectedItem.installmentDays

      //console.log("Alterando parcela: " + installments + " dias: " + installmentDays)

      var c=this.selectedItem.accounts.length
      // Altera valores
      var value = this.selectedItem.totalValue && this.selectedItem.totalValue > 0 ? this.selectedItem.totalValue : 0;
      var installmentValue = value > 0 ? this.$utils.roundFloor( this.selectedItem.totalValue / installments, 2) : 0;
      var installment0 = this.$utils.roundFloor(installmentValue + (this.selectedItem.totalValue - ( installmentValue * installments )), 2)

      for(const item of this.selectedItem.accounts) {
        item.totalValue = installmentValue
      }

      // Cria entradas de parcelas
      if(c < installments) {
        for(; c < installments ; c++) {
          this.selectedItem.accounts.push({ id: (c+1), installment: (c+1), dueDate: null, totalValue: installmentValue })
        }
      }
      else {
        for(; c > installments; c--) {
          this.selectedItem.accounts.pop();
        }
      }

      var installmentDate = this.selectedItem.dueDate;

      for(var i=0; i < installments; i++) {
        if(i==0) {
          this.selectedItem.accounts[i].totalValue = installment0
        }
        else {
          this.selectedItem.accounts[i].totalValue = installmentValue
        }
        this.selectedItem.accounts[i].dueDate = this.$utils.dateFormat(installmentDate)

        //console.log("parcel: " + i + " data: " + installmentDate)
        
        installmentDate = this.addDays( installmentDate, installmentDays+1)
      }

      },

      handleSelectedPerson(obj) {
        //console.log("Pessoa selecionada: ")
        this.personDoc = obj.doc
        this.personCode = obj.id
      },

      addHours(date, hours) {
      var result = new Date(date);
      result.setDate(result.getHours() + hours);
      return result;
      },

      addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
      },

      getRowCount: function () {
        if(this.items)
            return this.items.length
        else
            return 0;
      },
     

      async saveItem(currentItem) {

        //console.log('Salvando conta')
        //console.log(currentItem);

        var s = this;
        var postData = {...currentItem};

        postData.dueDate = postData.dueDate + "T12:00:00.000Z"
        postData.uid = this.$store.state.currentUser.id
        postData.sid = this.$store.state.currentUser.sid
        postData.personId = this.personCode
        postData.personName = this.personName
        postData.personDoc = this.personDoc        
        if(postData.paymentDate) {
           postData.paymentDate = postData.paymentDate + "T12:00:00.000Z"
        }
        
        //console.log(postData)
            
        await axios.post(
            this.$store.state.ws_url + "/finance/ar",
            postData
        ).then(function() {
            s.closeEditModal()
            s.refreshData();
          }
        ).catch(function (error) {
          // console.log(error);

          toast ({
            type: VueNotifications.types.warn,
            title: 'Contas a Receber',
            message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
            timeout: 5000
          })
        });
        
      },

      save() {

        var needRequired = false
        
        if(!this.selectedItem.dueDate) {
          needRequired=true
          this.dueDateField = 'is-invalid'  
        }
        else {
          this.dueDateField = ''
        }

        if(!this.selectedItem.totalValue) {
          needRequired = true
          this.totalValueField = 'is-invalid'
        }
        else {
          this.totalValueField = ''
        }
        
        if(!needRequired) {
          this.selectedItem.companyId = this.filters.companyId;
          this.selectedItem.uid = this.$store.state.currentUser.id;
          this.selectedItem.sid = this.$store.state.currentUser.sid;
          this.saveItem(this.selectedItem);
      }
      /*
        else {
          toast ({
            type: VueNotifications.types.error,
            title: 'Conta a Receber',
            message: 'Favor preencher os campos obrigatórios: Descrição, Data de vencimento e Valor',
            timeout: 3000
          })
        }
        */
      },

      async changeStatusItem(item, statusId) {
        var s = this;

        var postData = {
          id: item.id,
          statusId: statusId,
          notes: (item.notes ? item.notes : null),
          uid: s.$store.state.currentUser.id,
          sid: s.$store.state.currentUser.sid
        }
        await axios.post(
            this.$store.state.ws_url + "/finance/ar/changestatus",
            postData
        ).then(function() {
            s.closeEditModal()
            s.refreshData();
          }
        ).catch(function (error) {
          //console.log(error);

          toast ({
            type: VueNotifications.types.warn,
            title: 'Contas a Receber',
            message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
            timeout: 5000
          })
        });
        
      },

      changeStatus(item, statusId) {
        //console.log('Habilitando/desabilitando modelo')
        //console.log(item);
        //console.log(statusId);
        this.changeStatusItem(item, statusId)

      },

      openAccountPaymentModal() {
        this.accountPaymentModal = true
      },

      closeEditModal() {
        this.editModal = false;
      },
      openEditModal(item) {
        this.tabInfo = "D"
        this.dueDateField = ''
        this.totalValueField = ''
        if(item == null) {
            this.selectedItem = {...newItem};      
            this.selectedItem.dueDate = this.$utils.dateFormat(new Date())
            this.personCode = ""
            this.personDoc = ""
            this.personName = ""
        }
        else {
            this.selectedItem = JSON.parse(JSON.stringify(item));
            this.personCode = this.selectedItem.personId
            this.personName = this.selectedItem.personName
            this.personDoc = this.selectedItem.personDoc
            
        }
        this.editModal = true;
      },
      onRowSelected(items) {
        /*
        if(item == null) {
            this.selectedItem = newItem;      
        }
        else {
            this.selectedItem = JSON.parse(JSON.stringify(item));
        }
        */
        this.selected = items
        //console.log(items);
        //this.openEditModal(items[0])
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows();
      },
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      rowClicked(item) {
        if(!this.tableSelectable) {
            this.clearSelectedRows();
            this.openEditModal(item);
        }
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },
      toggleBusy() {
        this.isBusy = !this.isBusy
      },

      differenceChanged(obj) {
         //console.log("Diferença: " + obj)
        this.refreshData()
      },
      
      async getCostCenter(companyId) {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        await axios.get(
            this.$store.state.ws_url + "/costcenter/ddl?companyId=" + companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid        
        ).then(function(resp) {
          s.costCenterDDL = resp.data.obj;
        }).catch(function (error) {
          console.log(error);
        });
      },

      async getPersonByDoc(doc) {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        
        await axios.get(
          this.$store.state.ws_url + "/person?companyId=" + s.filters.companyId + "&key=" + s.$utils.numbersOnly(doc) + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
          var persons = resp.data.obj;
          if(persons && persons.length > 0) {
            var person = persons[0]
            s.personCode = person.id
            s.personName = person.name
          }
        }).catch(function(error) {
          console.log(error);
        });

      },

      async getPersonByCode(code) {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        
        await axios.get(
          this.$store.state.ws_url + "/person?companyId=" + s.filters.companyId + "&code=" + code + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
          var persons = resp.data.obj;
          if(persons && persons.length > 0) {
            var person = persons[0]
            s.personDoc = ( person.doc ? (person.doc.length > 11 ? s.$utils.formatCNPJ(person.doc) : s.$utils.formatCPF(person.doc) ) : '')
            s.personName = person.name
          }
        }).catch(function(error) {
          console.log(error);
        });
       
      },

      async getStatus() {
        var s = this
        var currentUser = this.$store.state.currentUser;
        
        await axios.get(
            this.$store.state.ws_url + "/finance/ap/status/ddl?uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
          s.statusDDL = resp.data.obj;       
        }).catch(function(error) {
          console.log(error);
        });
    
      },

      refreshByCompany(companyId) {
        this.getCostCenter(companyId);
        this.refreshData();
      },
      async refreshData() {

            var s = this;
            var currentUser = this.$store.state.currentUser;
        
            this.isBusy = true
            await axios.get(
                this.$store.state.ws_url + "/finance/ar?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
                 + ( s.filters.startDate ? "&startDate=" + s.filters.startDate : "")
                 + ( s.filters.endDate ? "&endDate=" + s.filters.endDate : "")
            ).then(function(resp) {
              s.items = resp.data.obj;
            }).catch(function(error) {
              console.log(error);
            });
                     
            this.isBusy = false;
      },
      openHelp(url) {
        window.open(this.$store.state.config.ws_help + url, '_blank')
      }
    },
    mounted: function() {

      var now = new Date();

      // Primeiro dia
      this.filters.startDate = this.$utils.dateFormat(new Date(now.getFullYear(), now.getMonth(), 1))
      // Último dia
      this.filters.endDate = this.$utils.dateFormat(new Date(now.getFullYear(), now.getMonth() + 1, 0))

      this.companyDDL = this.$store.state.currentUser.companies
      var companyId = this.$store.state.config.companyId
      this.filters.companyId = companyId;
      this.isBusy = true;
      this.getStatus()
      this.refreshByCompany(companyId);

    }
  }
  </script>
  
  <style scoped>
  table#table-transition-example .flip-list-move {
  transition: transform 1s;
  }
  </style>